import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 2000 }
  }
  static targets = ["title", "message", "progress", "progressBar", "counter"]

  connect() {
    this.checkStatus()
  }

  disconnect() {
    window.clearTimeout(this.timeout)
    this.abortController?.abort()
  }

  async checkStatus() {
    this.abortController = new AbortController()

    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        cache: "no-store",
        signal: this.abortController.signal
      })

      if (!response.ok) throw new Error(`HTTP ${response.status}`)

      const result = await response.json()
      if (!result.processing) {
        Turbo.visit(window.location.href, { action: "replace" })
        return
      }
      this.updateProgress(result)
    } catch (error) {
      if (error.name === "AbortError") return
    }

    this.timeout = window.setTimeout(() => this.checkStatus(), this.intervalValue)
  }

  updateProgress(result) {
    if (result.status === "importing" || !this.hasProgressTarget) return

    const totalRows = Number(result.total_rows) || 0
    const processedRows = Number(result.processed_rows) || 0
    const totalLookups = Number(result.address_lookups_total) || 0
    const completedLookups = Number(result.address_lookups_completed) || 0
    const totalWork = totalRows + totalLookups

    if (totalRows === 0) {
      this.titleTarget.textContent = "Lendo planilha"
      this.messageTarget.textContent = "Conferindo o arquivo e o limite de pedidos."
      this.progressTarget.classList.add("d-none")
      this.counterTarget.textContent = ""
      return
    }

    this.progressTarget.classList.remove("d-none")
    const percent = Math.min(100, Math.round(100 * (completedLookups + processedRows) / totalWork))
    this.progressBarTarget.style.width = `${percent}%`
    this.progressTarget.setAttribute("aria-valuenow", percent)

    if (completedLookups < totalLookups) {
      this.titleTarget.textContent = "Consultando endereços"
      this.messageTarget.textContent = "Buscando os CEPs no Jaiminho."
      this.counterTarget.textContent = `${completedLookups} de ${totalLookups} CEPs consultados`
    } else if (processedRows < totalRows) {
      this.titleTarget.textContent = "Validando pedidos"
      this.messageTarget.textContent = "Conferindo os dados antes da revisão."
      this.counterTarget.textContent = `${processedRows} de ${totalRows} pedidos validados`
    } else {
      this.titleTarget.textContent = "Preparando revisão"
      this.messageTarget.textContent = "Organizando as linhas para conferência."
      this.counterTarget.textContent = `${totalRows} pedidos validados`
    }
  }
}
